module.exports = __webpack_public_path__ + "static/img/new-07.2ad5668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-07.png
// module id = VfUB
// module chunks = 0